import { BASEROW_CONFIG, getBaserowHeaders } from './config';

interface FieldOption {
  id: number;
  value: string;
  color: string;
}

interface BaserowField {
  id: number;
  type: string;
  name: string;
  order: number;
  select_options?: FieldOption[];
}

export async function fetchFieldOptions(fieldId: string): Promise<FieldOption[]> {
  if (!fieldId) {
    throw new Error('Field ID is required');
  }

  try {
    const response = await fetch(
      `${BASEROW_CONFIG.BASE_URL}/fields/table/${BASEROW_CONFIG.TABLE_ID}/`,
      {
        method: 'GET',
        headers: getBaserowHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch fields: ${response.statusText}`);
    }

    const fields: BaserowField[] = await response.json();
    const field = fields.find(f => f.id.toString() === fieldId);

    if (!field) {
      throw new Error(`Field ${fieldId} not found`);
    }

    if (!field.select_options) {
      throw new Error(`Field ${fieldId} does not have select options`);
    }

    return field.select_options;
  } catch (error) {
    console.error('Error fetching field options:', error);
    throw error;
  }
}